export default ({
  submitAnswer,
  disabled, 
  language,
}) => {

  const onSubmit = event => {
    event.preventDefault()
    submitAnswer(event.currentTarget.answer.value)
  }

  return <>
    <form onSubmit={onSubmit}>
      <input
        type="text"
        name="answer"
        disabled={disabled}
        placeholder={language && `Type in ${language.name_eng}`}
        autoFocus
        required
      />
      <button className="button" type="submit" disabled={disabled}>Submit</button>
    </form>
  </>
}
